import statuses from '../../statuses';
import JiraTypes from './types';
import JiraService from '../../../services/jira';

export default {
  [JiraTypes.JIRA_PROJECTS]: ({ commit, state }, { page, filter }) => {
    state.jiraProjects['status'] = statuses.LOADING;
    JiraService.list(page, filter).then((data) => {
      commit(JiraTypes.JIRA_PROJECTS, data);
    }).catch((errResponse) => {
      commit(JiraTypes.JIRA_PROJECTS, errResponse);
    });
  },
  [JiraTypes.JIRA_PROJECTS_UPDATE]: ({ commit, state }, { id, isActive }) => {
    state.jiraProjectsUpdate['status'] = statuses.LOADING;
    JiraService.changeProjectImport(id, isActive).then((data) => {
      commit(JiraTypes.JIRA_PROJECTS_UPDATE, data);
    }).catch((errResponse) => {
      commit(JiraTypes.JIRA_PROJECTS_UPDATE, errResponse);
    });
  },
  [JiraTypes.JIRA_PROJECTS_PUSH_UPDATE]: ({ commit, state }, id) => {
    state.jiraProjectsPushUpdate['status'] = statuses.LOADING;
    JiraService.jiraProjectsPushUpdate(id).then((data) => {
      commit(JiraTypes.JIRA_PROJECTS_PUSH_UPDATE, data);
    }).catch((errResponse) => {
      commit(JiraTypes.JIRA_PROJECTS_PUSH_UPDATE, errResponse);
    });
  },
  [JiraTypes.JIRA_ISSUES]: ({ commit, state }, page = 1) => {
    state.jiraIssues['status'] = statuses.LOADING;
    JiraService.listIssues(page).then((data) => {
      commit(JiraTypes.JIRA_ISSUES, data);
    }).catch((errResponse) => {
      commit(JiraTypes.JIRA_ISSUES, errResponse);
    });
  },
  [JiraTypes.JIRA_ISSUES_SEARCH]: ({ commit, state }, searchParams) => {
    state.jiraIssuesSearch['status'] = statuses.LOADING;
    JiraService.searchIssues(searchParams).then((data) => {
      commit(JiraTypes.JIRA_ISSUES_SEARCH, data);
    }).catch((errResponse) => {
      commit(JiraTypes.JIRA_ISSUES_SEARCH, errResponse);
    });
  },
  // [JiraTypes.JIRA_PROJECT_ISSUES]: ({ commit, state }, searchParams) => {
  //   state.jiraProjectIssues['status'] = statuses.LOADING;
  //   JiraService.projectIssues(searchParams).then((data) => {
  //     commit(JiraTypes.JIRA_PROJECT_ISSUES, data);
  //   }).catch((errResponse) => {
  //     commit(JiraTypes.JIRA_PROJECT_ISSUES, errResponse);
  //   });
  // },
  [JiraTypes.JIRA_ISSUE_DATA]: ({ commit, state }, jiraIssue) => {
    state.jiraIssueData['status'] = statuses.LOADING;
    JiraService.jiraIssueSubtasks(jiraIssue).then((data) => {
      commit(JiraTypes.JIRA_ISSUE_DATA, data);
    }).catch((errResponse) => {
      commit(JiraTypes.JIRA_ISSUE_DATA, errResponse);
    });
  },
  [JiraTypes.JIRA_PROJECTS_RESET_ENTITIES]: ({ commit, state }, projectId) => {
    state.jiraProjectsResetEntities['status'] = statuses.LOADING;
    JiraService.jiraProjectsResetEntities(projectId).then((data) => {
      commit(JiraTypes.JIRA_PROJECTS_RESET_ENTITIES, data);
    }).catch((errResponse) => {
      commit(JiraTypes.JIRA_PROJECTS_RESET_ENTITIES, errResponse);
    });
  },
};
